import { render, staticRenderFns } from "./Grades.vue?vue&type=template&id=32533ed5&scoped=true"
import script from "./Grades.vue?vue&type=script&lang=js"
export * from "./Grades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32533ed5",
  null
  
)

export default component.exports